
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/green",
      function () {
        return require("private-next-pages/green.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/green"])
      });
    }
  